import { createSlice } from "@reduxjs/toolkit";
import http from "../../common/cticApi";
import { setPostOrderDetailsInfo } from "../auth/orderLawyerInformationSlice";
// initial state
export const initialState = {
  loading: false,
  error: null,
  success: false,
  consentStatement: null,
  isConsentStatementSubmitted: false,
  editReasonRequired: false,
  editReasonInvalidInputs: true,
  idvDisplayMessage: null,
  propertyListForIDV: null,
};

// our slice
const additionalInfoSlice = createSlice({
  name: "additionalInfo",
  initialState,
  reducers: {
    setLoading: (state) => {
      state.loading = true;
    },
    setError: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
      state.success = false;
    },
    setSuccess: (state) => {
      state.loading = false;
      state.error = false;
      state.success = true;
    },
    setConsentStatement: (state, { payload }) => {
      state.consentStatement = payload;
    },
    seteditReasonRequired: (state, { payload }) => {
      state.editReasonRequired = payload;
    },
    seteditReasonInvalidInputs: (state, { payload }) => {
      state.editReasonInvalidInputs = payload;
    },
    setisConsentStatementSubmitted: (state, { payload }) => {
      state.isConsentStatementSubmitted = payload;
    },
    setIDVerificationDisplayMessage: (state, { payload }) => {
      state.idvDisplayMessage = payload;
    },
    setPropertyListForAdditionalInformationIDV: (state, { payload }) => {
      state.propertyListForIDV = payload;
    },
  },
});
// export the actions
export const {
  setLoading,
  setError,
  setSuccess,
  setConsentStatement,
  setIDVerificationDisplayMessage,
  setPropertyListForAdditionalInformationIDV,
  seteditReasonRequired,
  seteditReasonInvalidInputs,
  setisConsentStatementSubmitted,
} = additionalInfoSlice.actions;


export const additionalInfoSelector = (state) => state.additionalInfo;

// export the default reducer
export default additionalInfoSlice.reducer;

export const SubmitFile =
  (
    FileID,
    UserID,
    internalUser,
    FileNumber,
    dealType,
    underWritingOrderRequest,
    IDVPropertyRequest,
    AdditionalQuestionsRequest,
    { navigate }
  ) =>
    async (dispatch) => {
      try {
        dispatch(setLoading());
        let requestObj = {
          FileID: FileID,
          UnderwritingQuestions: underWritingOrderRequest,
          IDVPropertyRequest: IDVPropertyRequest,
          UnderwritingQuestionsForAdditionalInfo: AdditionalQuestionsRequest,
        };

        let req = {
          UserID: UserID,
          RequestObject: requestObj,
        };
        const results = await http.post("Order/Submit", req).then((result) => {
          return result;
        });

        if (results.data.responseCode == 0) {
          let status = results.data.responseObject.status;
          let isAutoAdjudicateFile =
            results.data.responseObject.isAutoAdjudicateFile;
          let request = {
            fileID: FileID,
            fileNumber: FileNumber,
            dealType: dealType === "Commercial" ? "Commercial" : "Residential",
            fileStatus: status,
          };
          dispatch(setPostOrderDetailsInfo(request));
          dispatch(GetPropertyListForAdditionalInformationIDV(FileID, UserID));
          if (isAutoAdjudicateFile) {
            if (internalUser) {
              navigate(`/downloadpolicies/${FileNumber}`);
            } else {
              navigate(`/orderconfirmation/${FileNumber}`);
            }
          } else {
            navigate(`/ordersummary/${FileNumber}`);
          }
          dispatch(setSuccess());
        }
      } catch (error) {
        const errorMessage =
          error.response && error.response.data
            ? error.response.data.title
            : error.message;
        dispatch(setError(errorMessage));
      }
    };

export const GetConsentStatements =
  (FileID, UserID, IsIDV = false) =>
    async (dispatch) => {
      try {
        dispatch(setLoading());
        let request = {
          FileID: FileID,
          IsIDV: IsIDV,
        };

        let req = { UserID: UserID, RequestObject: request };
        const results = await http
          .post("Order/GetConsentStatementByFileID", req)
          .then((result) => {
            return result;
          });

        if (results.data.responseCode == 0) {
          dispatch(setConsentStatement(results.data.responseObject));
          dispatch(setSuccess());
        }
      } catch (error) {
        const errorMessage =
          error.response && error.response.data
            ? error.response.data.message
            : error.message;
        dispatch(setError(errorMessage));
      }
    };

export const GetPropertyListForAdditionalInformationIDV =
  (FileID, UserID) => async (dispatch) => {
    try {
      dispatch(setLoading());
      let request = {
        FileID: FileID,
      };

      let req = { UserID: UserID, RequestObject: request };
      const results = await http
        .post("Order/GetPropertyListForAdditionalInformationIDVByFileID", req)
        .then((result) => {
          return result;
        });

      if (results.data.responseCode == 0) {
        dispatch(
          setPropertyListForAdditionalInformationIDV(
            results.data.responseObject
          )
        );
        dispatch(setSuccess());
      }
    } catch (error) {
      const errorMessage =
        error.response && error.response.data
          ? error.response.data.message
          : error.message;
      dispatch(setError(errorMessage));
    }
  };

export const GetIDVerificationDisplayMessage =
  (FileID, UserID) => async (dispatch) => {
    try {
      dispatch(setLoading());
      let request = {
        FileID: FileID,
      };

      let req = { UserID: UserID, RequestObject: request };
      const results = await http
        .post("Order/GetIDVerificationDisplayMessages", req)
        .then((result) => {
          return result;
        });

      if (results.data.responseCode == 0) {
        dispatch(setIDVerificationDisplayMessage(results.data.responseObject));
        dispatch(setSuccess());
      }
    } catch (error) {
      const errorMessage =
        error.response && error.response.data
          ? error.response.data.message
          : error.message;
      dispatch(setError(errorMessage));
    }
  };
